module.exports = __webpack_public_path__ + "static/media/VUMeterMask.221465f9.png";